<ng-template #notificationTemplate let-data="data">
  <div class="message-box {{ data.typeClass }}">
    <div class="icon"></div>
    <div class="text">{{ data.message }}</div>
  </div>
</ng-template>
